import React, { useState, useEffect } from "react";
import {
  Col,
  Row,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Table,
  Badge,
} from "reactstrap";
import { useHistory } from "react-router-dom";
import swal from "sweetalert";
import axios from "axios";
import { API_DONOR_DARAH, API_TIMEOUT } from "utils";
import { logApp } from "utils/func";

function HistoriDonor() {
  const history = useHistory();
  const [currentUser, setCurrentUser] = useState("");
  const [noHp, setNoHp] = useState("");
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [histori, setHistori] = useState([]);

  useEffect(() => {
    // Jika data yang disimpan di localStorage adalah dalam format JSON, Anda perlu menguraikannya menjadi objek
    if (!currentUser) {
      let user = localStorage.getItem("user");
      if (user) {
        user = JSON.parse(user);
        logApp(user.uid, "Histori Donor");
        setCurrentUser(user);
      } else {
        history.push("/login");
      }
    }
  }, []);

  const validate = () => {
    const newErrors = {};
    if (!noHp.trim()) newErrors.noHp = "Nomor HP wajib diisi";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const formatDateDisplay = (value) => {
    if (!value) return "-";
    const str = String(value);
    if (str.includes("T")) return str.split("T")[0];
    return str;
  };

  const handleCari = async (e) => {
    e.preventDefault();
    if (!validate()) {
      swal("Info", "Mohon isi nomor HP pendonor", "info");
      return;
    }
    setIsLoading(true);
    try {
      const res = await axios.get(
        `${API_DONOR_DARAH}histori-donor?noHp=${encodeURIComponent(noHp)}`,
        { timeout: API_TIMEOUT }
      );
      if (res.data?.success) {
        const data = res.data.data || [];
        setHistori(data);
        if (data.length === 0) {
          swal(
            "Info",
            "Riwayat donor tidak ditemukan untuk nomor HP ini",
            "info"
          );
        }
      } else {
        swal("Error", res.data?.message || "Gagal mengambil data", "error");
      }
    } catch (error) {
      const msg =
        error.response?.data?.message ||
        error.message ||
        "Terjadi kesalahan saat mengambil data";
      swal("Error", msg, "error");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className="content">
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <CardTitle tag="h4">Histori Donor</CardTitle>
              </CardHeader>
              <CardBody>
                <Form onSubmit={handleCari} style={{ marginBottom: "20px" }}>
                  <Row>
                    <Col md="8">
                      <FormGroup>
                        <Label for="noHp">
                          Nomor HP Pendonor{" "}
                          <span style={{ color: "red" }}>*</span>
                        </Label>
                        <Input
                          type="tel"
                          name="noHp"
                          id="noHp"
                          value={noHp}
                          onChange={(e) => {
                            setNoHp(e.target.value);
                            if (errors.noHp) {
                              setErrors((prev) => ({ ...prev, noHp: "" }));
                            }
                          }}
                          invalid={!!errors.noHp}
                          placeholder="Masukkan nomor HP pendonor"
                        />
                        {errors.noHp && (
                          <div className="invalid-feedback d-block">
                            {errors.noHp}
                          </div>
                        )}
                      </FormGroup>
                    </Col>
                    <Col
                      md="4"
                      style={{ display: "flex", alignItems: "flex-end" }}
                    >
                      <Button
                        color="primary"
                        type="submit"
                        disabled={isLoading}
                        style={{ width: "100%" }}
                      >
                        {isLoading ? (
                          <>
                            <i
                              className="fas fa-spinner fa-spin"
                              style={{ marginRight: "5px" }}
                            />
                            Memproses...
                          </>
                        ) : (
                          "Cari Histori"
                        )}
                      </Button>
                    </Col>
                  </Row>
                </Form>

                {histori.length > 0 && (
                  <Table responsive>
                    <thead className="text-primary">
                      <tr>
                        <th>No</th>
                        <th>Tanggal</th>
                        <th>Donor</th>
                        <th>Gol. Darah</th>
                        <th>Jumlah Kantung</th>
                        <th>Tujuan</th>
                      </tr>
                    </thead>
                    <tbody>
                      {histori.map((item, index) => (
                        <tr key={item.id || index}>
                          <td>{index + 1}</td>
                          <td>{formatDateDisplay(item.tanggal)}</td>
                          <td>
                            {item.nama_donor || "-"}
                            {item.no_hp_donor && (
                              <>
                                <br />
                                <small className="text-muted">
                                  {item.no_hp_donor}
                                </small>
                              </>
                            )}
                          </td>
                          <td>
                            <Badge color="info">
                              {item.golonganDarah || "-"}
                            </Badge>
                          </td>
                          <td>{item.jumlah_kantung || "-"}</td>
                          <td>{item.tujuan || "-"}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                )}

                {histori.length === 0 && !isLoading && (
                  <div className="text-center" style={{ padding: "50px" }}>
                    <p style={{ color: "#666" }}>
                      {noHp
                        ? "Tidak ada data histori untuk nomor HP ini"
                        : "Masukkan nomor HP untuk melihat histori donor"}
                    </p>
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default HistoriDonor;
